import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DEFAULT_COLOR } from '../../../../core/config/color-constants';

@Component({
  selector: 'app-colorpicker-field',
  templateUrl: './colorpicker-field.component.html',
  styleUrls: ['./colorpicker-field.component.css']
})
export class ColorpickerFieldComponent implements OnInit {
  @Input() id: string;
  @Input() controlName: string;
  @Input() key: string;
  @Input() form: FormGroup;
  @Input() class = 'colorpicker-field field';
  @Input() hideLabel = false;
  @Input() hideErrors = false;
  @Input() colorMode = 'presets';
  @Input() presetColors: string[];
  @ViewChild('error') error;

  color: string;
  toggle: false;

  ngOnInit(): void {
    if (this.form.value.color) {
      this.color = this.form.value.color;
    } else {
      this.color = DEFAULT_COLOR;
    }
  }

  setColor(color) {
    this.color = color;
    this.form.get('color').setValue(color);
    this.toggle = false;
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/components/forms/colorpicker-field/colorpicker-field.component.ts